import { useState } from "react";
import { FiBell } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import {
  OptInBanner,
  OptInIconWrapper,
  OptInContent,
  OptInTitle,
  OptInBody,
  OptInActions,
  OptInActivateButton,
  OptInDismissButton,
} from "./Styles";

interface PushOptInProps {
  onSubscribe: () => Promise<boolean>;
  onDismiss: () => void;
}

export const PushOptIn = ({ onSubscribe, onDismiss }: PushOptInProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleActivate = async () => {
    setIsLoading(true);
    await onSubscribe();
    setIsLoading(false);
  };

  return (
    <OptInBanner>
      <OptInIconWrapper>
        <FiBell size={20} />
      </OptInIconWrapper>
      <OptInContent>
        <OptInTitle>{t("common.pushOptIn.title")}</OptInTitle>
        <OptInBody>{t("common.pushOptIn.body")}</OptInBody>
        <OptInActions>
          <OptInActivateButton onClick={handleActivate} disabled={isLoading}>
            {isLoading ? t("common.pushOptIn.activateButtonLoading") : t("common.pushOptIn.activateButton")}
          </OptInActivateButton>
          <OptInDismissButton onClick={onDismiss}>{t("common.pushOptIn.dismissButton")}</OptInDismissButton>
        </OptInActions>
      </OptInContent>
    </OptInBanner>
  );
};
